import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES, POWERED_BY, SITE_DOMAINS} from "../consts";
import {ComponentController} from "../../infrastructure/controllers/component-controller";
import {RouteModel} from "../components/router/models/route-model";
import {RouterController} from "../components/router/router-controller";
import {BaseLinkModel} from "../../infrastructure/models/link/base-link-model";
import {StandingsWidgetState} from "../../widgets/standings-widget/models/standings-widget.state";

export class PoweredByChangeTitleHandler extends ActionHandler {
  controller: ComponentController;
  state: StandingsWidgetState;
  routerController: RouterController;
  type = ACTION_TYPES.poweredByChangeTitle;

  static injectables = [...ActionHandler.injectables, RouterController];

  constructor(routerController: RouterController) {
    super();

    this.routerController = routerController;
  }

  async action(params) {
    this.appStore.state.poweredByModel.text = this.createText(params.name);
    this.appStore.state.poweredByModel.link = this.createURL(params.linkModel);

    return params;
  }

  createText(competitionName): String {
    const defaultTerm: String = `${this.state.terms.WIDGET_POWERED_BY} {{ ${SITE_DOMAINS.default} }}`
    const term: String = this.state.poweredByTerm || defaultTerm;

    const text: String = this.state.termsUtils?.formatTerm(term, {
      COMPETITION: competitionName
    });

    return text;
  }

  createURL(linkModel: BaseLinkModel): String {
    const routeModel: RouteModel = this.routerController.findRouteByName(linkModel.name);
    const url: String = this.navigationManager.createUrl(routeModel.path, linkModel);
    const link: String = `${POWERED_BY.defaultLink}${url}`;

    return link;
  }
}
